// funciones para log.
import * as FxFetch from './FxFetch';

// archivos donde mostrar info en formato 'NombreArchivo.NombreFuncion'
const filesIncluded = [];

export const infox = async (fileNameAndFxName, message, object) => {
  if (filesIncluded.includes(fileNameAndFxName) || filesIncluded.includes(fileNameAndFxName.split('.')[0])) {
    console.log(" ");
    console.log(fileNameAndFxName + ": " + (message||''), object||'');
  }
}

export const errorx = async (fileNameAndFxName, object) => {
  console.log(" ");
  console.error(fileNameAndFxName, object||'');
}


export const logUserToDb = async (op, txDetail, txModule, inXXX) => {
  // 2026-05-20 - daq: guarda en i_user
  let record = {};
  record['op'] = 'U';
  record['txDetail'] = txDetail;
  record['txModule'] = txModule;
  record['inXXX'] = inXXX;
  Promise.all([FxFetch.doJsonF("general/log_user", null, record)]).then((result) => {
    if (result[0]) {
      if (result[0].theValue === 'OK') {
      }
    }
  });
}

export const logErrorToDb = async (txFileName, txFxName, txError) => {
  // 2026-05-20 - daq: guarda en i_user
  let record = {};
  record['txFileName'] = txFileName;
  record['txFxName'] = txFxName;
  record['txError'] = txError;
  return Promise.all([FxFetch.doJsonF("general/log_error", null, record)]).then((result) => {
    if (result[0]) {
      return result[0];
    }
  });
}